import React from 'react';

import LoadingSpinner from '../../../components/LoadingSpinner';

interface CreateImportModalFooterProps {
  onCancel: () => void;
  onCreate: () => void;
  isCreating: boolean;
  disabled: boolean;
}

const CreateImportModalFooter: React.FC<CreateImportModalFooterProps> = ({
  onCancel,
  onCreate,
  isCreating,
  disabled,
}) => {
  return (
    <div className='px-6 py-4 bg-gray-50 dark:bg-gray-700 flex justify-end space-x-3'>
      <button
        onClick={onCancel}
        disabled={isCreating}
        className='px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-600 border border-gray-300 dark:border-gray-500 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200'
      >
        Cancel
      </button>
      <button
        onClick={onCreate}
        disabled={disabled || isCreating}
        className='px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center'
      >
        {isCreating && (
          <LoadingSpinner color='border-white' className='-ml-1 mr-2' />
        )}
        {isCreating ? 'Creating...' : 'Create Bulk Upload'}
      </button>
    </div>
  );
};

export default CreateImportModalFooter;
